import { ShaderFactory } from "./types"
import { Unit } from "../types"

type ShaderProps = {
    autoScroll?: boolean
}

const useScroll: ShaderFactory<ShaderProps> = ({ autoScroll = true } = {}) => {
    return (input, tick, resolution) => {
        if (input.length > resolution.height) {
            return input.slice(input.length - resolution.height, input.length)
        }
        return input
    }
}

export default useScroll
